// Load all plugins and scripts
require('./bootstrap');

// Plugins
require('./plugins/owl.carousel');

// Components
require('./components/form');
require('./components/filter');
require('./plugins/lightcase');



// WEBPACK FOOTER //
// ./scripts/tc-export.js